import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface FabAction {
  id?: string;
  label: string;
  icon: string;
  /** ghost | outline | primary | danger */
  style?: "ghost" | "outline" | "primary" | "danger";
  onClick: () => void;
  /** Se presente mostra un nz-popconfirm con questo titolo */
  confirm?: string;
}

@Injectable({ providedIn: "root" })
export class FabService {
  private readonly _actions$ = new BehaviorSubject<FabAction[]>([]);
  readonly actions$ = this._actions$.asObservable();

  /** Sostituisce completamente le azioni correnti. */
  set(actions: FabAction[]): void {
    this._actions$.next(actions || []);
  }

  /** Svuota il FAB. */
  clear(): void {
    this._actions$.next([]);
  }
}
